<template>
  <div>
    <headers />
    <div class="head">
      <img src="@/assets/images/solutionDetailsBj.png" />
      <div class="title">    {{ details.name }}</div>
    </div>
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>资料获取</el-breadcrumb-item>
        <el-breadcrumb-item to="/information/solution">解决方案</el-breadcrumb-item>
        <el-breadcrumb-item>{{details.name }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content">
      <div class="menu">
        <div
          class="menuItem"
          @click="changAct(0)"
          :style="act == 0 ? 'color:#00D8C3' : ''"
        >
          行业概述
        </div>
        <div
          class="menuItem"
          @click="changAct(1)"
          :style="act == 1 ? 'color:#00D8C3' : ''"
        >
          解决方案
        </div>
      </div>
      <div class="contentItem">
        <div id="section0">
          <div class="headTab">行业概述</div>
          <div class="text">
            {{ details.industry }}
          </div>
        </div>
        <div id="section1">
          <div class="headTab mt-60">解决方案</div>
          <el-button class="preview" @click="toPdfIndex">预览/下载</el-button>
        </div>
      </div>
    </div>
    <footers />
  </div>
</template>

<script>
import headers from "@/components/header.vue";
import footers from "@/components/footer.vue";
import search from "@/components/search.vue";

import { solutionDetials, fileDownloadRecordAdd } from "@/api/lx";

export default {
  name: "Procucts",
  components: {
    headers,
    footers,
    search,
  },
  data() {
    return {
      act: 0,
      id: "",
      details: {},
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.getSolutionDetails();
  },
  mounted() {},
  methods: {
    /**
     * 切换页面锚点定位项
     * @param {number} val - 锚点序号
     * @returns {void}
     */
    changAct(val) {
      this.act = val;
      const section = document.getElementById("section" + val);
      if (section) {
        const targetTop = section.offsetTop - 75;
        console.log(section);
        window.scrollTo({
          top: targetTop,
          behavior: "smooth",
        });
      }
    },

    /**
     * 获取解决方案详情数据
     * @returns {void}
     */
    getSolutionDetails() {
      solutionDetials(this.id).then((res) => {
        this.details = res.data;
      });
    },

    /**
     * 点击预览/下载按钮：上报解决方案文件下载埋点记录(fileType=2)，并跳转到 PDF 预览页面
     * @returns {Promise<void>}
     */
    async toPdfIndex() {
      if (this.id) {
        try {
          await fileDownloadRecordAdd({
            dataId: String(this.id),
            fileType: 2, // 文件类型：2-解决方案
          });
        } catch (error) {
          console.error("解决方案下载埋点失败:", error);
        }
      }
      this.$router.push({
        path: "/pdf/index",
        query: { url: this.details.solutionUrl, name: this.details.name },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.head {
  width: 100%;
  height: 240px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  .title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 42px;
    color: #ffffff;
    position: relative;
    z-index: 100;
  }
  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
.content {
  width: 1400px;
  min-height: 500px;
  margin: 0 auto;
  display: flex;
  padding: 40px 80px;
  box-sizing: border-box;
  background-color: #fff;
  margin-top: 20px;
  margin-bottom: 55px;
  display: flex;
  cursor: pointer;
  .menu {
    width: 95px;
  }
  .menuItem {
    font-weight: 400;
    font-size: 22px;
    color: #00161a;
    margin-bottom: 25px;
  }
  .contentItem {
    width: 1193px;
    border-left: 1px solid #e6edf0;
    margin-left: 40px;
    padding-left: 40px;
    box-sizing: border-box;
    .headTab {
      width: 100%;
      height: 66px;
      box-sizing: border-box;
      background: #e6fbf9;
      padding-left: 30px;
      line-height: 66px;
      font-weight: 600;
      font-size: 22px;
      color: #00d8c3;
    }
    .text {
      width: 100%;
      word-break: break-all;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #525f66;
      line-height: 28px;
      text-align: left;
      font-style: normal;
      margin-top: 30px;
    }
    .preview {
      width: 127px;
      height: 47px;
      background: #00d8c3;
      font-weight: 600;
      font-size: 18px;
      margin-top: 30px;
      color: #ffffff;
      &.is-active,
      &:active {
        border: 1px solid #00d8c3; /* 更改为你想要的颜色 */
        outline: none; /* 移除默认的轮廓线 */
      }
    }
  }
}
</style>